var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#506D85",
    stroke: "#506D85",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.879 0H1.014C.454 0 0 .455 0 1.014v5.865c0 .56.455 1.014 1.014 1.014h5.865c.56 0 1.014-.455 1.014-1.014V1.014C7.893.454 7.438 0 6.879 0zm.407 6.879c0 .224-.183.407-.407.407H1.014c-.224 0-.407-.183-.407-.407V1.014c0-.224.183-.407.407-.407h5.865c.224 0 .407.183.407.407v5.865zM15.986 0h-5.865c-.56 0-1.014.455-1.014 1.014v5.865c0 .56.455 1.014 1.014 1.014h5.865c.56 0 1.014-.455 1.014-1.014V1.014C17 .454 16.545 0 15.986 0zm.407 6.879c0 .224-.183.407-.407.407h-5.865c-.224 0-.407-.183-.407-.407V1.014c0-.224.183-.407.407-.407h5.865c.224 0 .407.183.407.407v5.865zM6.879 9.107H1.014C.454 9.107 0 9.562 0 10.121v5.865C0 16.546.455 17 1.014 17h5.865c.56 0 1.014-.455 1.014-1.014v-5.865c0-.56-.455-1.014-1.014-1.014zm.407 6.88c0 .223-.183.406-.407.406H1.014c-.224 0-.407-.183-.407-.407v-5.865c0-.224.183-.407.407-.407h5.865c.224 0 .407.183.407.407v5.865zM16.696 12.75h-3.339V9.41c0-.167-.136-.303-.303-.303-.168 0-.304.136-.304.304v3.339H9.41c-.167 0-.303.136-.303.304 0 .167.136.303.304.303h3.339v3.34c0 .167.136.303.304.303.167 0 .303-.136.303-.304v-3.339h3.34c.167 0 .303-.136.303-.303 0-.168-.136-.304-.304-.304z",
    transform: "translate(1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateDashboard);
export default __webpack_public_path__ + "static/media/create-dashboard.5c57e15c1e6944f566b25ab0092da86e.svg";
export { ForwardRef as ReactComponent };